import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, ERROR_TEXT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Skeleton, Arrow } from "@/components/hm/Basics";
import { LandingNav } from "@/screens/landing/Top";
import { SiteFooter } from "@/components/hm/SiteFooter";
import { ReadProgress, groupSentences } from "@/screens/module/Parts";

const KEY = "hm_draft_m1";

const PublicClarity = ({ m }) => {
  const [note, setNote] = useState(() => localStorage.getItem(KEY) || "");
  useEffect(() => { if (note.trim()) localStorage.setItem(KEY, note); else localStorage.removeItem(KEY); }, [note]);
  return (
    <section style={{ marginTop: "2.5rem" }} data-testid="public-clarity-moment">
      <div className="pull" data-testid="clarity-insight">{m.clarity.insight}</div>
      <div className="journal">
        <span className="eyebrow">Tu momento de claridad</span>
        <label htmlFor="public-note" style={{ display: "block", margin: ".9rem 0 .4rem", fontWeight: 600, fontSize: 15 }}>{m.clarity.prompt}</label>
        <textarea id="public-note" value={note} onChange={(e) => setNote(e.target.value)} maxLength={2000}
          placeholder="Escribe aquí. Solo lo verás tú." data-testid="public-note-input" />
        <div className="journal-f">
          <span className="inline-flex items-center gap-1"><Lock size={12} /> Se guarda en este dispositivo hasta que crees tu espacio</span>
        </div>
      </div>
      <div className="done-card" data-testid="public-module-cta-card">
        <p className="hm-h2" style={{ fontSize: "1.35rem", margin: 0 }}>Guarda lo que has entendido.</p>
        <p className="text-muted" style={{ margin: ".8rem 0 0" }}>
          Crea tu espacio gratis. Tu nota pasa a tu diario de claridad y puedes seguir con Recursos y la Comunidad.
        </p>
        <div style={{ display: "flex", gap: ".6rem", flexWrap: "wrap", marginTop: "1.4rem" }}>
          <Link to="/registro" className="btn btn-primary mag wm-btn" data-testid="public-module-register">Crear mi espacio gratis <Arrow /></Link>
          <Link to="/entrar" className="btn btn-ghost" data-testid="public-module-login">Entrar</Link>
        </div>
      </div>
    </section>
  );
};

export default function PublicModule() {
  const { user } = useAuth();
  const [m, setM] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/public/modules/m1").then((r) => setM(r.data)).catch(() => setError(true));
  }, []);

  if (user) return <Navigate to="/academia/m1" replace />;
  return (
    <>
      <LandingNav />
      <main className="app-main" style={{ paddingTop: 110 }}>
        {error && <p className="text-danger" data-testid="public-module-error">{ERROR_TEXT}</p>}
        {!m && !error && <div className="reader"><Skeleton h={60} n={4} /></div>}
        {m && (
          <article className="reader" data-testid="public-module-page">
            <ReadProgress />
            <span className="eyebrow">Módulo de bienvenida · {m.duration} · Gratis, sin registro</span>
            <h3 data-testid="module-title">{m.title}</h3>
            {m.sections.map((s, i) => (
              <section key={s.title} className="reader-sec" data-testid={`module-section-${i}`}>
                <h4>{s.title}</h4>
                {groupSentences(s.body).map((p) => <p key={p}>{p}</p>)}
              </section>
            ))}
            <PublicClarity m={m} />
          </article>
        )}
      </main>
      <SiteFooter />
    </>
  );
}
